// src/App.js
import React from 'react';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './contexts/AuthContext'; // Make sure this path is correct

// 1. Import ToastContainer and its CSS
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import './styles/global.css'; // Uncomment if you have global styles

function App() {
  return (
    <AuthProvider>
      {/* You can add a general wrapper div here if needed for layout */}
      {/* <div className="app-container"> */}

        {/* 2. Place ToastContainer here */}
        <ToastContainer
          position="top-right"    // Common position
          autoClose={5000}        // Auto close after 5 seconds
          hideProgressBar={false}
          newestOnTop={false}     // Show newest toast on top
          closeOnClick
          rtl={false}
          pauseOnFocusLoss        // Pause toast when window loses focus
          draggable               // Allow toasts to be dragged
          pauseOnHover            // Pause auto-close on hover
          theme="colored"         // "light", "dark", or "colored" (uses success/error/info colors)
        />
        
        <AppRoutes />
        
      {/* </div> */}
    </AuthProvider>
  );
}

export default App;